<template>
  <div v-if="noAuthority" class="sale-rank-layer">無權限</div>
  <div class="sale-rank" :class="noAuthority ? 'unclickable' : ''">
    <div class="sale-rank-header">
      <div class="sale-rank-title block-title">銷售前十名</div>
      <div class="sale-rank-report-link block-link"></div>
    </div>
    <div class="sale-rank-container">
      <div class="rank-source">
        <div class="sale-rank-foods">商品</div>
        <div class="sale-rank-selectors">
          <div class="sale-rank-selector">
            <select id="foodRankType" v-model="rankType">
              <option
                v-for="type in rankTypes"
                :key="type.value"
                :value="type.value"
              >
                {{ type.text }}
              </option>
            </select>
          </div>
          <div class="sale-rank-selector">
            <select id="rankDateRange" v-model="dateRangeType">
              <option
                v-for="item in dateRangeTypes"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="rank-container">
        <div
          v-for="(food, index) in rankItems"
          :key="food.FoodId"
          class="rank-food"
        >
          <div class="rank-food-info">
            <div class="rank-food-ranking">{{ index + 1 }}.</div>
            <div class="rank-food-name">{{ food.FoodName }}</div>
          </div>
          <div class="rank-food-data">
            <div
              class="rank-food-bar"
              :style="
                index == 0
                  ? `width: calc(100% - ${compareUnitWidth}px);`
                  : `width: calc((100% - ${compareUnitWidth}px) * ${
                      food.CompareValue / rankItems[0].CompareValue
                    })`
              "
            ></div>
            <div class="rank-food-qty" :style="`width: ${compareUnitWidth}px`">
              {{ food.CompareValueText }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          FoodId: "001",
          FoodName: "烏龍奶茶",
          Qty: 300,
          Total: 15000,
        },
      ],
      rankItems: [],
      rankTypes: [
        {
          value: 0,
          name: "Qty",
          text: "銷量",
        },
        {
          value: 1,
          name: "Total",
          text: "銷售額",
        },
      ],
      rankType: null,
      dateRangeTypes: this.$enum.dateRangeType.getAll(),
      dateRangeType: null,
      checkTimer: null,
      authorities: null,
      noAuthority: false,
    };
  },
  computed: {
    compareUnitWidth() {
      let width = null;
      if (this.rankType == 0) {
        width = 32;
      } else if (this.rankType == 1) {
        width = 60;
      }
      return width;
    },
  },
  watch: {
    dateRangeType(newValue, oldValue) {
      if (!oldValue && oldValue !== 0) return;
      this.getItems({ RankType: this.rankType, DateRangeType: newValue });
    },
    rankType(newValue, oldValue) {
      if (!oldValue) return;
      this.getItems({ RankType: newValue, DateRangeType: this.dateRangeType });
    },
  },
  methods: {
    isShow() {
      const authority = this.authorities.find(function (data) {
        return data.AuthItemType == 20;
      });
      if (authority) {
        if (authority.IsList) return true;
      }
      return false;
    },
    getItems(obj) {
      let dTO = this.$func.getDateRange.getByType(this.dateRangeType);
      dTO.PageSize = 10;
      dTO.IsDesc = 1;
      if (obj) {
        this.RankType = obj.RankType;
        this.dateRangeType = obj.DateRangeType;
      }
      if (this.rankType == 0) {
        dTO.SortName = "Qty";
      } else if (this.rankType == 1) {
        dTO.SortName = "Total";
      }
      if (this.isShow()) {
        this.$api.reports.getFoodSaleStatistic(dTO).then((data) => {
          this.rankItems = data.Datas;
          if (this.rankType == 0) {
            this.rankItems.forEach((item) => {
              item.CompareValue = item.Qty;
              item.CompareValueText = item.Qty;
            });
          } else if (this.rankType == 1) {
            this.rankItems.forEach((item) => {
              item.CompareValue = item.Total;
              item.CompareValueText = this.$currencyFilter(item.Total);
            });
          }
          sessionStorage.setItem(
            "SaleRankDTO",
            JSON.stringify({
              RankType: this.rankType,
              DateRangeType: this.dateRangeType,
            })
          );
        });
      } else {
        this.noAuthority = true;
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.checkTimer);
  },
  created() {
    this.checkTimer = setInterval(() => {
      this.authorities = JSON.parse(localStorage.getItem("authorities"));
      if (this.authorities) {
        clearInterval(this.checkTimer);
        let dTO = null;
        if (sessionStorage.getItem("SaleRankDTO")) {
          dTO = JSON.parse(sessionStorage.getItem("SaleRankDTO"));
          this.rankType = dTO.RankType;
          this.dateRangeType = dTO.DateRangeType;
        } else {
          this.rankType = 0;
          this.dateRangeType = 2;
        }
        this.getItems(dTO);
      }
    }, 200); // 每200毫秒檢查一次
  },
};
</script>

<style lang="scss">
.sale-rank {
  position: relative;
  width: 100%;
  height: 100%;
  padding-bottom: 44px;
  &.unclickable {
    mix-blend-mode: lighten;
  }
}
.sale-rank-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sale-rank-report-link {
  text-align: end;
  color: #4695c9;
  font-weight: 500;
}
.sale-rank-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  background-color: white;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 5px;
  height: calc(100% - 63px);
  @media screen and (max-width: 991px) {
    height: 100%;
  }
}
.rank-source {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 10px;
}
.sale-rank-foods {
  font-weight: 500;
}
.sale-rank-selectors {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 50%;
  min-width: 160px;
}
.sale-rank-selector {
  width: 50%;
  max-width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  select {
    width: 100%;
    height: 40px;
    margin-left: 10px;
    padding: 1px 0 0 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #bababa;
    border-radius: 4px;
    font-size: 16px;
  }
}
.rank-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.rank-food {
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid #d1d1d1;
  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }
}
.rank-food-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.rank-food-name {
  margin-left: 8px;
}

.rank-food-data {
  display: flex;
  justify-content: flex-start;
  padding-left: 22px;
  align-items: center;
  width: 100%;
}
.rank-food-bar {
  height: 12px;
  background-color: #82b5d8;
  border-radius: 2px;
}
.rank-food-qty {
  padding-left: 5px;
  text-align: start;
  color: #727272;
  font-size: 14px;
}
.sale-rank-layer {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 20px;
  z-index: 12;
  @media screen and (min-width: 992px) {
    padding-right: 24px;
  }
}

@media screen and (min-width: 992px) {
  .homepage-grid.single-report #saleRank {
    .sale-rank-container {
      align-items: stretch;
    }

    .rank-container {
      flex: 1;
      min-height: 0;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-template-rows: repeat(5, minmax(0, 1fr));
      grid-auto-flow: column;
      column-gap: 60px;
      align-items: stretch;
    }

    .rank-food {
      min-width: 0;
    }
  }
}
</style>
